<template>
 <div class="tab-pane fade" id="AgentCreditReport" role="tabpanel"  aria-labelledby="home-tab">

                <div class="row col-sm-12">
                  
                   <form class="form-inline" role="form">
                   
               
                    <div class="input-group input-daterange mr-sm-2"><label class="mr-sm-2">Date Range</label><datepicker format="yyyy-MM-dd"  value="2019-01-01" v-model="startdate_credit" id="edstartdate_credit" :bootstrap-styling="true" class="datewidth"></datepicker><div class="input-group-prepend"><span class="input-group-text">to</span></div><datepicker format="yyyy-MM-dd"  value="2019-01-01" v-model="enddate_credit" id="edenddate_credit" :bootstrap-styling="true" class="datewidth"></datepicker> </div>

                    <div class="input-group mr-sm-2"><label class="mr-sm-2">Account</label>
                    <input class="form-control form-control-sm" v-model="edaccname" type="text" id="formGroupInputSmall" value=""></div>

                    <div class="input-group mr-sm-2"><label class="mr-sm-2">Trade Number</label>
                    <input class="form-control form-control-sm" v-model="edtradeno" type="text" id="formGroupInputSmall" value=""></div>

                    <div class="input-group mr-sm-2"><label class="mr-sm-2">IP</label>
                    <input class="form-control form-control-sm" v-model="edip" type="text" id="formGroupInputSmall" value=""></div>

                    <div class="input-group input-daterange mr-sm-2"><label class="mr-sm-2">Tx Type</label>
                    <select class="form-control" id="idgametype" v-model="edtranstype"><option selected="true" value="">All</option><option value="1">In</option><option value="2">Out</option></select></div>

                    <button type="button" class="btn btn-primary mb-2" id="btn_agentcredit" @click="getreport(startdate_edit,enddate_edit,edaccname,edtradeno,edip,edtranstype)">Search</button>

                  </form>
              

                </div>
                <div class="">
                 <div class="row mt-3" style="overflow-x: auto; white-space: nowrap;">
                  <div style="padding-left: 15px; width:2000px;">

                            <div class="row" style="white-space: nowrap;">
      <div class="row col-12" style="padding-bottom:20px;">
      <b-col lg="6" class="">
        <b-form-group
          label="Filter"
          label-cols-sm="3"
          label-align-sm="right"
          label-size="sm"
          label-for="filterInputcredit"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              v-model="filtercredit"
              type="search"
              id="filterInputcredit"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>

        </b-form-group>
      </b-col>

        <b-col sm="3" md="6" class="my-1">
      
      </b-col>
    </div>

    
                      <b-table
                      bordered=true
                      dark=true
                
                      show-empty

                      selectable
                      select-mode="single"
                      selected-variant="primary"
                      :items="dtrep"
                      :fields="fields"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filtercredit"
                      :filterIncludedFields="filterOn"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :sort-direction="sortDirection"
                      @filtered="onFiltered"
                      @row-selected="onRowSelectedMember"
                 
                    >
                       <template v-slot:cell(index)="data">
                        {{ data.index + 1 }} 
                      </template>

                      <template v-slot:cell(operate_time)="data">
                        {{ moment(data.value).format("YYYY-MM-DD HH:mm:ss") }} 
                      </template>
                    
                    </b-table>


                     <div class="row col-6">
    

      <b-col sm="7" md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="dtrep.length"
          per-page="10"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
      </b-col>
    </div>
                  </div>

                    

                  </div>
                </div>
              </div>
                </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import { mapGetters } from "vuex";
    import * as TYPES from "@/store/mutation-types";
    import api from '@/api'
    import moment from 'moment'

    export default {
      name: "agentcreditreport",
      components: {
          Datepicker
      },
      data: function() {
      return {
        mydatas : [],
        dataTable:null,
        dataTableAnak:null,
        indukdatas : [],
        dtrep : [],
        activeuser : "",
        activetype : "",
        activeket : "Agent",
        fields: [
          'index',
          { key : 'trade_number', label : 'Trade Number'},
          { key: 'operate_time', label: 'Operate Time', sortable: true,  },
          { key: 'account', label: 'Account'},
          { key: 'superior_agent', label: 'Superior Agent'},
          { key: 'tx_type', label: 'Tx Type'},
          { key: 'bal_before_tx', label: 'Bal Before Tx'},
          { key: 'transfer_in', label: 'Transfer In'},
          { key: 'transfer_out', label: 'Transfer Out'},
          { key: 'bal_after_tx', label: 'Bal After Tx'},
          { key: 'operator', label: 'Operator'},
          { key: 'ip', label: 'IP'},
          { key: 'remark', label: 'Remark'}
        ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filtercredit: null,
      filterOn: [],
    }
    },
  computed: {
   ...mapGetters(["allAgentCreditReport","singleUser"]),
   getAllCreditReports(){
      return this.allAgentCreditReport
   },
    getUser(){
      return this.singleUser
   },
  },
   methods : {
    getreport(startdate_edit='',enddate_edit='',edaccname='',edtradeno='',edip='',edtranstype=''){

        this.$store.dispatch(TYPES.FETCH_AGENTCREDITREPORTS).then(res => {
        });


        var awal = ''+$('#edstartdate_credit').val()+' 00:00:00';
        var akhir = ''+$('#edenddate_credit').val()+' 23:59:59';

      //  api.get('agent/credit/report').then(({ data }) => {
         //  var myarr = data.data;
           var myarr = this.getAllCreditReports;

          // debugger;
           this.mydatas = [];
           var search = '';

       if (edtranstype == 1){
         search='transfer_in'
       } else if (edtranstype == 2){
          search = 'transfer_out'
       } else {
         search = ""
       }


      var filter = new Object();

      if (edtradeno != ''){
        Object.assign(filter, {trade_number: edtradeno});
      }

      if (edip != ''){
         Object.assign(filter, {ip: edip});
      }
      
      // let myarr = this.getAllCreditReports;

       var arr2 = myarr.filter(function(item) {
          for (var key in filter) {
            if (item[key] === undefined || item[key] != filter[key]){
              return false;
            } else {
               if (edtranstype == "1" &&  item['transfer_out'] == null) {
                  return false;
               } else if (edtranstype == "2" &&  item['transfer_in '] == null){
                  return false;
               }
            }
            }
          return true;
      });

       var filter2 = new Object();

       if (awal != ''){
         Object.assign(filter2, {operate_time: awal});
       }


       var arr = arr2.filter(function(item) {
          for (var key in filter2) {
            var itemTime = new Date(item['operate_time']);
            var newawal = new Date(awal);
            var newakhir =  new Date(akhir);
            if (itemTime < newawal || itemTime > newakhir) {

              return false;
            
            } else {
               if (edtranstype == "1" &&  item['transfer_out'] == null) {
                  return false;
               } else if (edtranstype == "2" &&  item['transfer_in '] == null){
                  return false;
               }
            }
          }
          return true;
      });

       this.dataTableAnak.clear().draw();
      
       for (var i = arr.length - 1; i >= 0; i--) {
         
       
          this.dataTableAnak.row.add([i+1,arr[i].trade_number,arr[i].operate_time,arr[i].account,arr[i].superior_agent,arr[i].tx_type,arr[i].bal_after_tx,arr[i].transfer_in,arr[i].transfer_out,arr[i].bal_after_tx,arr[i].operator,arr[i].ip,arr[i].remark
          ]).draw(false)

      } 

     this.dtrep = arr;
     // this.allAgentCreditReport = arr;
      // var result =  mydatas.filter(mydata => mydata.gameType.toLowerCase().indexOf(search) > -1);

      //  }); 
    },
    doMath: function(index) {
        return index+1
      },
    moment: function (time) {
    return moment(time);
  },
  },
  mounted(){
    //this.$store.dispatch(TYPES.FETCH_AGENTCREDITREPORTS)
    this.$store.dispatch(TYPES.FETCH_AGENTCREDITREPORTS).then(res => {
          //  this.dtrep = this.getAllCreditReports();
            document.getElementById('btn_agentcredit').click();
      });

    this.dataTableAnak = $(this.$refs.tabcreditrep).DataTable({});
    setTimeout(() => this.mydatas = fakeData(50), 1000);

   
  },
  watch: {
  getAllCreditReports(val) {
    this.dataTableAnak.destroy();
    this.$nextTick(() => {
      this.dataTableAnak = $(this.$refs.tabcreditrep).DataTable()
    });
  }
},
  }
</script>